/* Omelva · ficha de la braguita · 3 de 3: galería deslizable, guía de tallas y barra fija de compra.
   La barra sale solo cuando no se ve el selector ni el botón, y se esconde con el aviso de cookies,
   el teclado abierto, la guía de tallas, el cajón del carrito o el pie a la vista. */
(function () {
  var O = window.OMPF;
  if (!O || !O.form) return;
  var t = O.t;

  /* ---------- galería ---------- */

  var pista = document.querySelector('[data-ompf-pista]');
  if (pista) {
    var slides = [].slice.call(pista.querySelectorAll('.ompf-slide'));
    var minis = [].slice.call(document.querySelectorAll('[data-ompf-mini]'));
    var contador = document.querySelector('[data-ompf-contador]');
    var calentado = false;
    var temp = null;

    var indiceActual = function () { return pista.clientWidth ? Math.round(pista.scrollLeft / pista.clientWidth) : 0; };
    var irA = function (i, sinAnimar) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      pista.scrollTo({ left: i * pista.clientWidth, behavior: (O.reducido() || sinAnimar) ? 'auto' : 'smooth' });
    };
    /* El vídeo no se descarga al abrir la ficha (preload none): empieza a bajar en cuanto se mueve la galería. */
    var calienta = function () {
      if (calentado) return;
      calentado = true;
      pista.querySelectorAll('video[data-ompf-video]').forEach(function (v) { if (v.preload === 'none') v.preload = 'auto'; });
    };
    var arranca = function (v) {
      calienta();
      v.muted = true; v.defaultMuted = true;
      if (O.reducido()) { v.setAttribute('controls', ''); return; }
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.setAttribute('controls', ''); });
    };
    var repasa = function () {
      var i = indiceActual();
      slides.forEach(function (s, j) {
        var v = s.querySelector('video');
        if (!v) return;
        if (j === i) arranca(v); else if (!v.paused) v.pause();
      });
      minis.forEach(function (m, j) { if (j === i) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current'); });
      var activa = minis[i];
      if (activa && activa.parentNode && activa.parentNode.scrollTo) {
        var cont = activa.parentNode;
        cont.scrollTo({ left: Math.max(0, activa.offsetLeft - cont.clientWidth / 2 + activa.clientWidth / 2), behavior: 'auto' });
      }
      if (contador) contador.textContent = (i + 1) + ' / ' + slides.length;
    };

    pista.addEventListener('scroll', function () { calienta(); clearTimeout(temp); temp = setTimeout(repasa, 90); }, { passive: true });
    document.querySelectorAll('[data-ompf-mover]').forEach(function (b) {
      b.addEventListener('click', function () { calienta(); irA(indiceActual() + parseInt(b.getAttribute('data-ompf-mover'), 10)); });
    });
    minis.forEach(function (m) {
      m.addEventListener('click', function () { calienta(); irA(parseInt(m.getAttribute('data-ompf-mini'), 10)); });
    });
    pista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); irA(indiceActual() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); irA(indiceActual() - 1); }
    });
    window.addEventListener('resize', function () { clearTimeout(temp); temp = setTimeout(repasa, 150); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) slides.forEach(function (s) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); });
      else repasa();
    });
    repasa();
    O.galeria = { irASlide: function (s, sinAnimar) { var i = slides.indexOf(s); if (i >= 0) irA(i, sinAnimar); } };
    if (O.estado && O.estado.color) O.mostrarColor(O.estado.color);
  }

  /* ---------- guía de tallas: se abre encima del selector y al cerrar vuelve el foco a donde estaba ---------- */

  var modal = document.getElementById('ompf-modal-tallas');
  var abridor = null;
  document.querySelectorAll('[data-ompf-tallas]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!modal || typeof modal.showModal !== 'function') return;
      e.preventDefault();
      abridor = a;
      modal.showModal();
      var x = modal.querySelector('.ompf-modal-x');
      if (x) x.focus();
      pintarBarra();
    });
  });
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || (e.target.closest && e.target.closest('[data-ompf-cerrar-tallas]'))) modal.close();
    });
    modal.addEventListener('close', function () {
      if (abridor) try { abridor.focus(); } catch (e) {}
      pintarBarra();
    });
  }

  /* ---------- barra fija ---------- */

  var barra = document.getElementById('ompf-barra');
  var visibles = {};
  var foco = false;

  function bannerCookies() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var r = b.getBoundingClientRect();
    var cs = getComputedStyle(b);
    return r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }
  function tecladoAbierto() {
    var vv = window.visualViewport;
    return foco || (vv && vv.height < window.innerHeight * 0.72);
  }
  function pintarBarra() {
    if (!barra) return;
    var cajon = !!document.querySelector('.omj.on');
    var dialogo = !!document.querySelector('dialog[open]');
    var ver = window.scrollY > 380 && !visibles.packs && !visibles.tc && !visibles.compra && !visibles.pie &&
      !cajon && !dialogo && !tecladoAbierto() && !bannerCookies();
    var r = O.packElegido();
    if (r) {
      barra.querySelector('[data-ompf-barra-pack]').textContent = r.getAttribute('data-nombre');
      barra.querySelector('[data-ompf-barra-precio]').textContent = r.getAttribute('data-precio');
    }
    barra.querySelector('[data-ompf-barra-btn]').textContent = O.completo() ? t('pagar', 'Continuar al pago') : t('barraElegir', 'Elegir talla y color');
    if (barra.hidden === !ver) return;
    barra.hidden = !ver;
    document.body.classList.toggle('ompf-con-barra', ver);
  }
  O.pintarBarra = pintarBarra;

  if (barra) {
    var vigilar = {
      packs: document.querySelector('.ompf-packs'),
      tc: document.getElementById('ompf-tc'),
      compra: document.getElementById('ompf-compra'),
      pie: document.querySelector('footer')
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          for (var k in vigilar) if (vigilar[k] === en.target) visibles[k] = en.isIntersecting;
        });
        pintarBarra();
      });
      for (var k in vigilar) if (vigilar[k]) io.observe(vigilar[k]);
    }
    window.addEventListener('scroll', pintarBarra, { passive: true });
    window.addEventListener('resize', pintarBarra);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', pintarBarra);
    document.addEventListener('focusin', function (e) {
      foco = !!(e.target && e.target.matches && e.target.matches('input:not([type=radio]):not([type=checkbox]), textarea, select'));
      pintarBarra();
    });
    document.addEventListener('focusout', function () { foco = false; setTimeout(pintarBarra, 50); });
    setInterval(pintarBarra, 1500);
    barra.querySelector('[data-ompf-barra-btn]').addEventListener('click', function () {
      if (O.completo() && O.pagar) { O.pagar(); return; }
      O.ensenarFaltas();
    });
    pintarBarra();
  }
})();